var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "wine_medium",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#dac892", "stroke-width": "0px" },
        attrs: {
          d: "m38.835,48.5c-4.3-5.7-4.5-15.1-3.8-23.1l.6-.2c2-.8,3.9-1.7,7.5-1.7s5.5.8,7.5,1.6c2.1.9,4.3,1.8,8.3,1.8,2.7,0,4.6-.4,6-.9.8,7.8.4,17-3.7,22.5-2.5,3.3-6.3,5-11.2,5s-8.7-1.7-11.2-5Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m62.866,49.7c9-11.9,1.7-37.9,1.4-39-.1-.4-.5-.7-1-.7h-26.6c-.4,0-.8.3-1,.7-.3,1.1-7.5,27,1.5,38.9,2.7,3.6,6.7,5.5,11.7,5.8v32.6h-9c-.6,0-1,.4-1,1s.4,1,1,1h20.1c.6,0,1-.4,1-1s-.4-1-1-1h-9v-32.5c5.2-.3,9.1-2.2,11.9-5.8ZM37.466,12h25c.4,1.7,1.6,6.4,2.2,12-1.4.5-3.1,1-5.8,1-3.6,0-5.5-.8-7.5-1.6-2.1-.9-4.3-1.8-8.3-1.8-3.7,0-5.8.8-7.8,1.6.8-5.3,1.8-9.6,2.2-11.2Zm1.4,36.5c-4.3-5.7-4.5-15.1-3.8-23.1l.6-.2c2-.8,3.9-1.7,7.5-1.7s5.5.8,7.5,1.6c2.1.9,4.3,1.8,8.3,1.8,2.7,0,4.6-.4,6-.9.8,7.8.4,17-3.7,22.5-2.5,3.3-6.3,5-11.2,5s-8.7-1.7-11.2-5Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }